export const ROUTES = {
  LANDING: '/',
  HOME: '/home',
  PROFILES: '/profiles',
  PROFILE_DETAIL: '/profiles/:id',
  SOS: '/sos',
  LOCATION: '/location',
  SESSIONS: '/sessions',
  COMMUNITY: '/community',
  FIND_HELP: '/find-help',
  MESSAGING: '/messaging',
  MESSAGING_THREAD: '/messaging/:conversationId',
  SETTINGS: '/settings',
  ORG: '/org',
  ORG_TEAM: '/org/team',
  COMMAND_CENTER: '/command-center',
  COMMAND_CENTER_USERS: '/command-center/users',
  COMMAND_CENTER_USER_DETAIL: '/command-center/users/:uid',
  COMMAND_CENTER_ORGS: '/command-center/orgs',
  COMMAND_CENTER_EMAILS: '/command-center/emails',
  COMMAND_CENTER_SOS: '/command-center/sos',
  COMMAND_CENTER_PANIC: '/command-center/panic',
  COMMAND_CENTER_RESOURCES: '/command-center/resources',
  COMMAND_CENTER_IDS: '/command-center/ids',
  COMMAND_CENTER_MAINTENANCE: '/command-center/maintenance',
  MISSION_CONTROL: '/mission-control',
  FEEDBACK: '/feedback',
  TERMS: '/terms',
  PRIVACY_POLICY: '/privacy',
  PRIVACY_POLICY_LEGACY: '/privacy-policy',
  SECURITY_PRIVACY: '/security-privacy',
  ABOUT: '/about',
  DEPENDENT_SAFETY: '/dependent-safety',
  INVITE_ACCEPT: '/invite/:id',
  ORG_INVITE_ACCEPT: '/org-invite/:id',
  ORG_APPLY: '/org/apply',
  ORG_ENROLLED: '/org/enrolled',
  ORG_NOTES: '/org/notes',
  ORG_SOS: '/org/sos',
  ORG_LOCATION: '/org/location',
  ORG_CAMERA: '/org/camera',
  ORG_PENDING: '/org/pending',
  ORG_SETTINGS: '/org/settings',
  QR: '/qr',
  AAC: '/aac/:profileId',
  PANIC_WATCH: '/panic-watch/:uid?',
  FUNDER: '/funder',
  HAZARDS: '/hazards',
  WEATHER: '/weather',
  PASSPORT: '/p/:token',
  VERIFY_EMAIL: '/verify-email',
  AUTH_ACTION: '/auth/action',
  ONBOARDING: '/onboarding',
  REGISTER: '/register',
  /** Public recovery URL — always signs out family Firebase session and lands on /. */
  LOGOUT: '/logout',
} as const
